import { createSectionForm } from "./sectionFormKit";

// Customer: components/sections/CartRecover/CartRecover.js
const CartRecover = createSectionForm({
  icon: "shopping-cart-2-line",
  title: "Recovered Cart",
  fields: [
    { name: "title", label: "Title", placeholder: "Your Cart" },
    { name: "empty_title", label: "Empty Cart Title", placeholder: "Cart is Empty" },
    { name: "empty_button_text", label: "Empty Cart Button", placeholder: "Shop Now" },
  ],
});

export default CartRecover;
